import { useEffect, useRef, useState } from "react";

export default function ContactSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="contact"
      ref={sectionRef}
      className="py-16 md:py-24 bg-dark-950"
    >
      <div className="px-4 md:px-8 lg:px-12 max-w-4xl mx-auto">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-900 text-primary-300 text-xs font-semibold tracking-wider uppercase mb-4">
            Get Started
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white mb-4">
            We Can Help!
          </h2>
          <p className="text-dark-300 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Call for daily special pricing. Speak to an expert — not a robot.
          </p>
        </div>

        <div
          className={`grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 transition-all duration-700 delay-200 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <a
            href="tel:754-777-6321"
            className="group flex items-center gap-5 p-6 md:p-8 rounded-xl bg-dark-900 border border-dark-800 hover:border-primary-600 transition-all cursor-pointer"
          >
            <div className="w-14 h-14 rounded-xl bg-primary-600 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
              <i className="ri-phone-line text-white text-2xl" />
            </div>
            <div>
              <div className="text-dark-400 text-xs font-medium uppercase tracking-wider mb-1">
                Call Now
              </div>
              <div className="text-white font-heading font-semibold text-lg md:text-xl whitespace-nowrap">
                (754) 777-6321
              </div>
            </div>
          </a>

          <a
            href="mailto:info@fastestcreditrestoration.com"
            className="group flex items-center gap-5 p-6 md:p-8 rounded-xl bg-dark-900 border border-dark-800 hover:border-primary-600 transition-all cursor-pointer"
          >
            <div className="w-14 h-14 rounded-xl bg-primary-600 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
              <i className="ri-mail-line text-white text-2xl" />
            </div>
            <div>
              <div className="text-dark-400 text-xs font-medium uppercase tracking-wider mb-1">
                Email Us
              </div>
              <div className="text-white font-heading font-semibold text-sm md:text-base break-all">
                info@fastestcreditrestoration.com
              </div>
            </div>
          </a>

          <a
            href="mailto:fastcreditrestorationinfo@gmail.com"
            className="group flex items-center gap-5 p-6 md:p-8 rounded-xl bg-dark-900 border border-dark-800 hover:border-primary-600 transition-all cursor-pointer md:col-span-2"
          >
            <div className="w-14 h-14 rounded-xl bg-primary-600 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
              <i className="ri-mail-send-line text-white text-2xl" />
            </div>
            <div>
              <div className="text-dark-400 text-xs font-medium uppercase tracking-wider mb-1">
                Backup Email
              </div>
              <div className="text-white font-heading font-semibold text-sm md:text-base break-all">
                fastcreditrestorationinfo@gmail.com
              </div>
            </div>
          </a>
        </div>

        <div
          className={`mt-10 md:mt-12 text-center transition-all duration-700 delay-400 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <p className="text-dark-400 text-sm">
            We get back to you within 48 hours
          </p>
        </div>
      </div>
    </section>
  );
}